import { useEffect, useState } from 'react'
import { useAuthContext } from '../../hooks/useAuthContext'
import { useCollection } from '../../hooks/useCollection'
import AddAndDrop from './AddAndDrop';

// components
import StudentForm from './StudentForm'
import StudentsInfo from './StudentsInfo'
import ResponseCard from '../../components/ResponseCard'
import { useFirestore } from '../../hooks/useFirestore'
import { Col, Container, Row } from 'react-bootstrap'
import { projectFirestore } from '../../firebase/config'
import Chatbot from '../../components/Chatbot';

export default function Home({portalStatus}) {
  const [studentStatus, setStudentStatus] = useState("Pending");
  const [rejectionReason, setRejectionReaoson ] = useState('');
  const [new_subjects, setNewSubjects] = useState([])
  const { user } = useAuthContext()
  const {updateDocument} = useFirestore('students')
  const { documents: studentDoc, error } = useCollection(
    'students', ["student_id", "==", user.email.match(/\d+/)[0]]

  )
  const [studentId, setStudentId] = useState()
  const [academicStatus, setAcademicStatus] = useState()
  
   const getId = () => {

    const query = projectFirestore.collection("students").where("student_id", "==", user.email.match(/\d+/)[0] );
    query.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        setStudentId(doc.id)
         
      });
    })
    .catch((error) => {
      console.log("Error getting documents: ", error);
    });
   }

   useEffect(() => {
     getId()
   }, [user])


   
  const handleResubmit = () => {
   
     setStudentStatus("Pending") 

    const data = {
        status : "Pending",
        new_subjects : [],
        rejectionReason: "" 
         
      }

     updateDocument(studentId, data)

  }

  useEffect(() => {
    studentDoc?.map((studentData) => {
      console.log('studentData', studentData)
        setStudentStatus(studentData.status)
        setRejectionReaoson(studentData.rejectionReason)
        setNewSubjects(studentData.new_subjects)
        setAcademicStatus(studentData.academic_status)
    })    
  
  }, [studentDoc])

  return (
  
    <>
  
    <Container >
         
      {!studentDoc && <div style={{height:'90vh'}} className='d-flex m-6 justify-content-center align-items-center'>
        <div style={{width: '100px', height: '100px'}} class="spinner-border text-primary" role="status">
       <span class="visually-hidden">Loading...</span>
          </div>
         </div> }
      
         {academicStatus === "DISM" ?
          <ResponseCard academic_status={academicStatus} status={studentStatus} reason={rejectionReason} />
          :
          (studentStatus === "Pending" && new_subjects?.length) || studentStatus !== "Pending" ?
            <ResponseCard newSubjects={new_subjects} academic_status={academicStatus} handleResubmit={handleResubmit} status={studentStatus} reason={rejectionReason} />
            
   :   <>  <h3> تسجيل المقررات </h3>
   <p > قم بترك الصناديق في حالة عدم الحاجة لها</p>
   <hr style={{color: 'white'}}/>
    <Row className='home-view'>
      <Col  style={{margin: "auto"  }} md={6} xs={12}>
   {portalStatus === "OPEN_PRE" &&      <StudentForm uid={studentId}  student={studentDoc}  portalIsOpen={portalStatus} /> }
   {portalStatus === "OPEN_FIN" && <AddAndDrop uid={studentId}  student={studentDoc} portalIsOpen={portalStatus}  />}
        </Col>
        <Col md={6} xs={12}>
         <StudentsInfo status={studentStatus} students={studentDoc} />

        </Col>
      
      </Row>  </>}
    </Container>

  </>
  )
}
